<template>
  <!--悬浮小广告样式的提示信息-->
  <div
    id="float-modal"
    ref="modelRef"
    v-show="model.showModel"
    @mouseover="clearFdAd"
    @mouseout="starFdAd"
  >
    <div class="close-btn text-xl" @click="model.showModel = false">
      <el-icon class="text-xl" style="vertical-align: text-top"
        ><Close
      /></el-icon>
      关闭
    </div>
    <!-- <div
      @click="handleClick"
      title="查看详情"
      style="
        cursor: pointer;
        background-color: rgba(255, 255, 255, 0.5);
        padding: 0.25rem;
      "
    >
      <div v-html="title" />
    </div> -->
    <div @click="handleClick" style="cursor: pointer" title="查看详情">
      <!-- <img :src="cover" width="100%" border="0" /> -->
      <el-image :src="cover" fit="fill" />
    </div>
  </div>
</template>

<script setup>
import {
  nextTick,
  onMounted,
  reactive,
  ref,
  defineProps,
  defineEmits,
  onUnmounted
} from 'vue'
import { Close } from '@element-plus/icons-vue'

import Img from '@/assets/images/swiper-1.png'
let interval

const props = defineProps({
  title: {
    type: String
  },
  cover: {
    type: String
  }
})

const emits = defineEmits(['on-click'])

const model = reactive({
  xPos: 0,
  yPos: 0,
  xin: true,
  yin: true,
  step: 1,
  delay: 18,
  height: 0,
  Hoffset: 0,
  Woffset: 0,
  yon: 0,
  xon: 0,
  pause: true,
  showModel: true
})

const modelRef = ref()

const changePos = () => {
  let width = document.documentElement.clientWidth
  let height = document.documentElement.clientHeight

  model.Hoffset = modelRef.value?.offsetHeight //获取元素高度
  model.Woffset = modelRef.value?.offsetWidth

  // 滚动部分跟随屏幕滚动
  // modelRef.value.style.left = (model.xPos + document.body.scrollLeft + document.documentElement.scrollLeft) + "px";
  // modelRef.value.style.top = (model.yPos + document.body.scrollTop + document.documentElement.scrollTop) + "px";

  // 滚动部分不随屏幕滚动
  if (modelRef.value) {
    modelRef.value.style.left = model.xPos + document.body.scrollLeft + 'px'
    modelRef.value.style.top = model.yPos + document.body.scrollTop + 'px'
  }

  if (model.yon) {
    model.yPos = model.yPos + model.step
  } else {
    model.yPos = model.yPos - model.step
  }
  if (model.yPos < 0) {
    model.yon = 1
    model.yPos = 0
  }
  if (model.yPos >= height - model.Hoffset) {
    model.yon = 0
    model.yPos = height - model.Hoffset
  }

  if (model.xon) {
    model.xPos = model.xPos + model.step
  } else {
    model.xPos = model.xPos - model.step
  }
  if (model.xPos < 0) {
    model.xon = 1
    model.xPos = 0
  }
  if (model.xPos >= width - model.Woffset) {
    model.xon = 0
    model.xPos = width - model.Woffset
  }
}

const clearFdAd = () => {
  clearInterval(interval)
}

const starFdAd = () => {
  interval = setInterval(changePos, model.delay)
}

const handleClick = () => {
  emits('on-click')
}

onMounted(() => {
  nextTick(() => {
    interval = setInterval(changePos, model.delay)
  })
})

onUnmounted(() => {
  interval && clearInterval()
})
</script>

<style lang="scss" scoped>
#float-modal {
  z-index: 9999;
  position: absolute;
  top: 43px;
  left: 2px;
  // height: 9.75rem;
  width: 11.25rem;
  .close-btn {
    position: absolute;
    right: 2px;
    top: -22px;
    cursor: pointer;
    color: #999999;
  }

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
